var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconValidateFeatureRelease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.406 2.938 9.062.594A1.988 1.988 0 0 0 7.657 0H2C.875 0 0 .906 0 2v12c0 1.125.875 2 2 2h8c1.094 0 2-.875 2-2V4.344c0-.532-.219-1.032-.594-1.407zM10.5 14c0 .281-.25.5-.5.5H2a.494.494 0 0 1-.5-.5V2.031c0-.281.219-.5.5-.5h5V4c0 .563.438 1 1 1h2.469v9h.031zm-5.313-3.844L4.25 9.22c-.313-.281-.781-.281-1.063 0-.312.312-.312.781 0 1.062l1.5 1.5A.753.753 0 0 0 5.25 12a.783.783 0 0 0 .563-.25l3-3.5a.779.779 0 0 0-.094-1.063.779.779 0 0 0-1.063.094l-2.468 2.875z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconValidateFeatureRelease);
export default __webpack_public_path__ + "static/media/survey-icon-validate-feature-release.14046073c9983b30f559c0d7c3aaad52.svg";
export { ForwardRef as ReactComponent };